import * as React from 'react'

import { useMediaQueries } from '../custom-hooks'

export const Desktop = (props: { children: React.ReactNode }): React.ReactNode => {
	const { isDesktop } = useMediaQueries()
	return isDesktop ? props.children : null
}

export const DesktopOrLaptop = (props: { children: React.ReactNode }): React.ReactNode => {
	const { isDesktopOrLaptop } = useMediaQueries()
	return isDesktopOrLaptop ? props.children : null
}

export const Laptop = (props: { children: React.ReactNode }): React.ReactNode => {
	const { isLaptop } = useMediaQueries()
	return isLaptop ? props.children : null
}

export const Tablet = (props: { children: React.ReactNode }): React.ReactNode => {
	const { isTablet } = useMediaQueries()
	return isTablet ? props.children : null
}

export const TabletLandscape = (props: { children: React.ReactNode }): React.ReactNode => {
	const { isTabletLandscape } = useMediaQueries()
	return isTabletLandscape ? props.children : null
}

export const TabletPortrait = (props: { children: React.ReactNode }): React.ReactNode => {
	const { isTabletPortrait } = useMediaQueries()
	return isTabletPortrait ? props.children : null
}

export const TabletLandscapeAtLeast = (props: { children: React.ReactNode }): React.ReactNode => {
	const { isTabletLandscapeAtLeast } = useMediaQueries()
	return isTabletLandscapeAtLeast ? props.children : null
}

export const Mobile = (props: { children: React.ReactNode }): React.ReactNode => {
	const { isMobile } = useMediaQueries()
	return isMobile ? props.children : null
}
